import type { Nil } from '@pbt/pbt-ui-components'

import { ClinicStatus } from '~/api/graphql/generated/types'

export enum ClinicDisplayStatus {
  Verified = 'VERIFIED',
  Unverified = 'UNVERIFIED',
  // Closed = 'CLOSED', We will not have this for PMR phase 1
}

const VERIFIED_STATUSES = new Set([ClinicStatus.Active])

export const getClinicDisplayStatus = (
  status: ClinicStatus | Nil,
): ClinicDisplayStatus => {
  if (!status) {
    return ClinicDisplayStatus.Unverified
  }

  if (VERIFIED_STATUSES.has(status)) {
    return ClinicDisplayStatus.Verified
  }

  return ClinicDisplayStatus.Unverified
}
